<template>
  <artmisads-modal :visible.sync="visible" :title="title" width="500px" @cancel="visible = false" :maskClosable="false"
    :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
    <div>

      <a-form :model="formState" :loading="loading" name="basic" :label-col="{ span: 5 }" autocomplete="off"
        ref="formRef">

        <a-form-item label="选择站点" name="marketplace" :rules="[{ required: true, message: '请选择站点' }]">
          <div ref="marketplaceRef">
            <artmisads-select :allowClear="true" :disabled="disabled" style="width: 100%"
              v-model:value="formState.marketplace" :getPopupContainer="() => marketplaceRef"
              :options="COUNTRY_BASE_OPTIONS" />
          </div>
        </a-form-item>
        <a-form-item label="ASIN" name="asin" :rules="[{ required: true, message: '请输入ASIN' }]">
          <a-input v-model:value="formState.asin" />
        </a-form-item>
      </a-form>
    </div>
    <template #footer>
      <div class="footer">
        <artmisads-button isSquare="true" @click="visible = false">取消</artmisads-button>
        <artmisads-button isSquare="true" type="primary" @click="onSubmit">确定</artmisads-button>
      </div>
    </template>
  </artmisads-modal>
</template>
<script setup>
import { ref, defineExpose, onMounted, defineEmits } from 'vue'
import { COUNTRY_BASE } from "~/contants/common"
import { financeApi } from "~/server/operator/finance"
import { message } from 'ant-design-vue'
const marketplaceRef = ref(null)

const formRef = ref(null)
const visible = ref(false)
const loading = ref(false)
const title = ref('新建敏感商品')
const COUNTRY_BASE_OPTIONS = COUNTRY_BASE.map((item) => {
  item.value = item.host
  item.label = item.host
  return item
})
const emits = defineEmits(['submit'])
const formState = ref({
  asin: '',
  marketplace: '',
})
const onSubmit = async () => {
  formRef.value.validate().then(res => {
    financeApi.addProductSensitiveAsin({
      asin: formState.value.asin,
      marketplace: formState.value.marketplace,
    }).then(res => {
      if (res.success) {
        message.success('添加成功')

        visible.value = false
        formRef.value.resetFields()
        emits('submit')
      } else {
        message.error(res.error || '添加失败')
      }
    })

  })

  // ElMessage.success('调整成功');
  // visible.value = false
  // formRef.value.resetFields();

}
defineExpose({
  show () {
    visible.value = true
    formRef.value.resetFields()
  },
})
</script>
<style scoped lang="less">
.autoComplete {
  :deep(.ant-select-selector) {
    height: 32px !important;

  }

  :deep(.ant-select-selection-search-input) {
    height: 32px !important;
  }

  :deep(.ant-select-selection-placeholder) {
    line-height: 32px !important;
  }
}
</style>